"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElasticSearchHostNoHttpsUrl = void 0;
const common_enums_1 = require("@klear/common-enums");
function getElasticSearchHostNoHttpsUrl(elasticsearchEnum = common_enums_1.ElasticsearchEnum.Klear) {
    switch (elasticsearchEnum) {
        case common_enums_1.ElasticsearchEnum.Klear:
            return common_enums_1.ElasticsearchHostNoHttpsEnum.Klear;
        case common_enums_1.ElasticsearchEnum.KlearDev:
            return common_enums_1.ElasticsearchHostNoHttpsEnum.KlearDev;
        case common_enums_1.ElasticsearchEnum.ChineseProd:
            return common_enums_1.ElasticsearchHostNoHttpsEnum.ChineseProd;
        default:
            throw Error("Illegal elasticsearch cluster enum value");
    }
}
exports.getElasticSearchHostNoHttpsUrl = getElasticSearchHostNoHttpsUrl;
//# sourceMappingURL=elasticsearchUtils.js.map